import { Box, ModBox, TextNew } from '@jfs/ui-new'
import { FC, useEffect, useState } from 'react'
import { useStores } from '../../data/store'
import { GridList } from '../GridList'

interface GridContainerListProps {
  type: number
  isAllChecked: boolean
  isEdit?: boolean
  setIsAllChecked: (isChecked: boolean) => void
}

const GridContainerList: FC<GridContainerListProps> = ({
  type,
  isAllChecked,
  isEdit,
  setIsAllChecked,
}: GridContainerListProps) => {
  const {
    updateSelection,
    searchString,
    getInstrumentsListWithSearch,
    banksSelectedLength,
    walletSelectedLength,
    payLaterSelectedLength,
    getPaymentsListByType,
    corpBankSelectedLength,
  } = useStores((root) => ({
    updateSelection: root.updateSelection,
    searchString: root.onboarding.searchString,
    getInstrumentsListWithSearch: root.getInstrumentsListWithSearch,
    banksSelectedLength: root.banksSelectedLength(),
    walletSelectedLength: root.walletSelectedLength(),
    payLaterSelectedLength: root.payLaterSelectedLength(),
    getPaymentsListByType: root.getPaymentsListByType,
    corpBankSelectedLength: root.corporateBanksSelectedLength(),
  }))
  const [matrixList, setMatrixList] = useState([[]])

  useEffect(() => {
    const dataList = getInstrumentsListWithSearch(`${type}`, searchString, isAllChecked)
    setMatrixList(dataList)
  }, [
    getInstrumentsListWithSearch,
    isAllChecked,
    searchString,
    type,
    banksSelectedLength,
    getPaymentsListByType,
    payLaterSelectedLength,
    walletSelectedLength,
    corpBankSelectedLength,
  ])

  const onItemChecked = (id: string, isChecked: boolean) => {
    updateSelection(id, isChecked, type)
    if (isChecked === false) {
      setIsAllChecked(false)
    }
  }
  console.log('matrixList length: ', matrixList.length)
  return (
    <Box flex={1}>
      <ModBox
        show={matrixList?.length > 0}
        h={matrixList.length % 2 === 0 ? (matrixList.length / 2) * 64 : ((matrixList.length + 1) / 2) * 64}
        w={'100%'}
        borderWidth={1}
        borderColor={'BORDER_COLOR'}
        borderRadius={8}>
        <GridList
          data={matrixList}
          type={type}
          onItemChecked={onItemChecked}
          columnCount={2}
          isEdit={isEdit}
          itemHeight={64}
        />
      </ModBox>
      <ModBox show={matrixList?.length === 0}>
        <TextNew title="No data found" color={'PRIMARY'} fontSize={16} fontWeight="BOLD" />
      </ModBox>
    </Box>
  )
}

export { GridContainerList }
